import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncLocalStorage } from 'redux-persist/storages';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise';
import { routerMiddleware } from 'react-router-redux';
import history from '../utils/history';
import reducers from './reducers';

const middlewares = [thunkMiddleware, promiseMiddleware, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  const { logger: loggerMiddleware } = require('redux-logger'); // eslint-disable-line global-require

  middlewares.push(loggerMiddleware);
}

function configureStore(onComplete) {
  const composeEnhancers = (typeof window === 'object') && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : compose;

  const enhancers = composeEnhancers(
    applyMiddleware(...middlewares),
    autoRehydrate()
    // other store enhancers if any
  );

  const store = createStore(reducers, enhancers);

  persistStore(store, {
    storage: asyncLocalStorage,
    whitelist: [
      'auth'
    ]
  }, onComplete);

  if (module.hot) {
    module.hot.accept(() => {
      const nextReducer = require('./reducers').default; // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

export { configureStore as createStore };